export default "__VITE_ASSET__BUT_H_7u__"